import { render, staticRenderFns } from "./RecommendationReportsList.vue?vue&type=template&id=8acba124&scoped=true"
import script from "./RecommendationReportsList.vue?vue&type=script&lang=ts"
export * from "./RecommendationReportsList.vue?vue&type=script&lang=ts"
import style0 from "./RecommendationReportsList.vue?vue&type=style&index=0&id=8acba124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acba124",
  null
  
)

export default component.exports